export class SimpleSelectionItem {
    // Värdet för objektet
    value: any;
    // Eventuellt id för objektet
    id?: any;
    // Texten som presenteras för objektet
    text: string;
    // Eventuell gruppering
    group?: any;
}
